import pageConfig from '@PROJECT_ROOT/responsiveFrontendPagesConfiguration.json';
import { apiFetchData, apiPostDataWithLangISO } from '@PROJECT_ROOT/assets/responsive-frontend/js/services/apiService';

// Servis za hendlanje svih AI API requesta.
export default class AIService {
    // POST-a podatke sa API-a "/reservation/price-calculation-details/{twoLetterISOLanguageCode}".
    static postAIPath(postMessage) {
        const { askAIPath } = pageConfig.AISearchPage;

        return apiPostDataWithLangISO(
            askAIPath,
            postMessage,
        );
    }

    // GET-a podatke sa API-a "/ai-search-form/{twoLetterISOLanguageCode}".
    static getAISearchFormData(lang) {
        const { searchFormPath } = pageConfig.AISearchPage;

        return apiFetchData(
            searchFormPath,
            null,
            lang && lang,
        );
    }

    // GET-a podatke sa API-a "/accommodation/private/search/results-on-list/{page}/{twoLetterISOLanguageCode}".
    static getAISearchResultsData(lang, reservationParametersQuery) {
        const { searchResultsPath } = pageConfig.AISearchPage;

        return apiFetchData(
            searchResultsPath,
            `${reservationParametersQuery}`,
            lang && lang,
        );
    }
}
